/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SavingsPlanDetailsFilters {
    getFixupPrototypeFunction() { return SavingsPlanDetailsFilters.fixupPrototype; }

    static newInstance(model: Partial<SavingsPlanDetailsFilters>): SavingsPlanDetailsFilters {
        let obj = Object.assign(new SavingsPlanDetailsFilters(), model);
        SavingsPlanDetailsFilters.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SavingsPlanDetailsFilters>): SavingsPlanDetailsFilters {
        if (!model) return null;
        return SavingsPlanDetailsFilters.newInstance(<SavingsPlanDetailsFilters> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SavingsPlanDetailsFilters) {
        if (!obj) return;

        models.SavingsPlanDetailsFilters.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SavingsPlanDetailsFilters): boolean {
        Object.setPrototypeOf(obj, SavingsPlanDetailsFilters.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Service account IDs to filter
     */
    service_account_ids: Array<string>;

}
